import { c as _c } from "react/compiler-runtime";
import type { ChangelogPost } from '@onefootprint/changelog';
import { IcoChevronDown16 } from '@onefootprint/icons';
import type { Organization } from '@onefootprint/request-types/dashboard';
import { cx } from 'class-variance-authority';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import useSession, { type UserSession } from '@/hooks/use-session';
import NavDropdown from '../nav-dropdown';
type NavFooterProps = {
  isCollapsed: boolean;
  currTenantId: string;
  assumedTenant?: {
    id: string;
    name: string;
  };
  onAssumeTenant: (tenantId: string) => void;
  isSwitchingTenant?: boolean;
  tenants: Organization[];
  posts: ChangelogPost[];
  user?: UserSession;
};
const NavFooter = t0 => {
  const $ = _c(33);
  const {
    isCollapsed,
    currTenantId,
    assumedTenant,
    onAssumeTenant,
    isSwitchingTenant,
    tenants,
    posts,
    user
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.privateLayout.nav"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  const {
    dangerouslyCastedData
  } = useSession();
  const org = dangerouslyCastedData?.org;
  let t2;
  if ($[1] !== org?.name) {
    t2 = org?.name?.charAt(0).toUpperCase() ?? "";
    $[1] = org?.name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const initial = t2;
  let t3;
  if ($[3] !== initial || $[4] !== org) {
    t3 = org?.logoUrl ? <div className="flex items-center justify-center rounded-full overflow-hidden size-5 shrink-0"><img src={org.logoUrl} alt={org.name} className="h-full w-full object-cover" /></div> : <div className="flex items-center justify-center rounded-full bg-neutral-inverted text-quinary text-caption-3 size-5 shrink-0">{initial}</div>;
    $[3] = initial;
    $[4] = org;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const avatar = t3;
  const t4 = isCollapsed ? "size-7 justify-center mx-auto" : "justify-between gap-2 h-8 md:h-7 w-full pl-1 pr-1.5";
  let t5;
  if ($[6] !== t4) {
    t5 = cx("group flex items-center rounded-default hover:bg-hover group-data-[state=open]:bg-senary/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 cursor-pointer", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t(_temp);
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== avatar || $[11] !== isCollapsed || $[12] !== org?.name) {
    t7 = isCollapsed ? avatar : <><div className="flex items-center gap-2 min-w-0">{avatar}<span className="text-label-3 text-primary truncate">{org?.name}</span></div><span className="flex items-center text-tertiary group-hover:text-primary"><IcoChevronDown16 /></span></>;
    $[10] = avatar;
    $[11] = isCollapsed;
    $[12] = org?.name;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <button type="button" className={t5} aria-label={t6}>{t7}</button>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const trigger = t8;
  const t9 = isCollapsed ? "px-3" : "pl-3.5 pr-3";
  let t10;
  if ($[18] !== t9) {
    t10 = cx("h-14 shrink-0 py-3 md:py-3.5", t9);
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== assumedTenant || $[21] !== currTenantId || $[22] !== isCollapsed || $[23] !== isSwitchingTenant || $[24] !== onAssumeTenant || $[25] !== posts || $[26] !== tenants || $[27] !== trigger || $[28] !== user) {
    t11 = user ? <Suspense fallback={<div className="h-7 w-full" />}><NavDropdown currTenantId={currTenantId} assumedTenant={assumedTenant} onAssumeTenant={onAssumeTenant} isSwitchingTenant={isSwitchingTenant} tenants={tenants} user={user} posts={posts} triggerFullWidth={!isCollapsed}>{trigger}</NavDropdown></Suspense> : trigger;
    $[20] = assumedTenant;
    $[21] = currTenantId;
    $[22] = isCollapsed;
    $[23] = isSwitchingTenant;
    $[24] = onAssumeTenant;
    $[25] = posts;
    $[26] = tenants;
    $[27] = trigger;
    $[28] = user;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t10 || $[31] !== t11) {
    t12 = <div className={t10}>{t11}</div>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};
export default NavFooter;
function _temp($) {
  return $.account;
}